import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TZyomuinKyuyoDownloadCsvPostReq,
  TZyomuinKyuyoInfoGetRes,
  TZyomuinKyuyoListGetReq,
  TZyomuinKyuyoPostReq,
  // TZyomuinKyuyoRegisterPutReq,
  TZyomuinKyuyoZissekiPutReq,
} from "./TZyomuinKyuyo"

/**
 * 乗務員給与に対するAPIリクエスト用サービス
 *
 * @export
 * @class ZyomuinKyuyoService
 * @extends {ConnectApi}
 */
export default class ZyomuinKyuyoService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TZyomuinKyuyoListGetReq} params
   * @memberof ZyomuinKyuyoService
   */
  getList = async (params: TZyomuinKyuyoListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinKyuyoInfoGetRes[]>> =
        await this.getInner(`/driverpayroll/zyomuinkyuyo/v2/list`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 給与実績データ作成・更新
   *
   * @param {TZyomuinKyuyoRegisterPutReq} data
   * @memberof ZyomuinKyuyoService
   */
  create = async (data: TZyomuinKyuyoPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/driverpayroll/zyomuinkyuyo/v2/create`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 給与実績更新
   *
   * @param {TZyomuinKyuyoRegisterPutReq} data
   * @memberof ZyomuinKyuyoService
   */
  put = async (data: TZyomuinKyuyoZissekiPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/driverpayroll/zyomuinkyuyo/v2/update`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 稼働調整後の給与実績に稼働調整適用処理
   *
   * @param {TZyomuinKyuyoRegisterPutReq} data
   * @memberof ZyomuinKyuyoService
   */
  稼働調整後update = async (data: TZyomuinKyuyoPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/driverpayroll/zyomuinkyuyo/v2/updateafterkadotyosei`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * CSVダウンロード処理
   *
   * @param {TZyomuinKyuyoDownloadCsvPostReq} params
   * @memberof ZyomuinKyuyoService
   */
  downloadCsv = async (params: TZyomuinKyuyoDownloadCsvPostReq) => {
    try {
      const res: AxiosResponse<Blob> = await this.postInner(
        `/driverpayroll/zyomuinkyuyo/v2/actions/downloadcsv`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
